<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.gatehouseAdd") }}</h3>
            </div>
            <div class="card-body">
                <div class="p-4">
                    <GatehouseForm ref="gatehouseForm" @submit="addGatehouse" />
                </div>
            </div>
        </div>

        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white" @click="submitForm">{{ $t("utils.save") }}</button>
        </div>
    </div>
</template>

<script>
import GatehouseForm from '@/components/dashboard/GatehouseForm.vue';

export default {
    components: {
        GatehouseForm,
    },
    methods: {
        submitForm() {
            if (this.$refs.gatehouseForm?.submitForm) {
                this.$refs.gatehouseForm.submitForm();
            }
        },
        addGatehouse(data) {
            const formData = {
                name: data.name,
                address: data.address,
            }

            this.$store.getters.api.post(`/dashboard/${this.$route.params.slug}/gatehouse/add`, formData)
            .then((res) => {
                this.$store.commit("addGatehouse", res.data);
                this.$router.push({
                    name: "GatehouseView",
                    params: {
                        slug: res.data.slug
                    }
                });
            })
            .catch(error => {
                console.error("Error adding gatehouse.", error);
            });
        }
    }
}
</script>